import commonScripts from './common';

window.addEventListener('load', () => {
	commonScripts();
});
